import { render, staticRenderFns } from "./xwdt.vue?vue&type=template&id=6f68494b&scoped=true&"
import script from "./xwdt.vue?vue&type=script&lang=js&"
export * from "./xwdt.vue?vue&type=script&lang=js&"
import style0 from "./xwdt.vue?vue&type=style&index=0&id=6f68494b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68494b",
  null
  
)

export default component.exports